import LogEventContext from "components/charting/contexts/LogEventContext";
import useDefinedContext from "./useDefinedContext";

function useLogEventContext() {
  return useDefinedContext(LogEventContext);
}
export default useLogEventContext;
